import { render } from "./Modal.vue?vue&type=template&id=1b45b59c&scoped=true"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"

import "./Modal.vue?vue&type=style&index=0&id=1b45b59c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1b45b59c"

export default script